/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Types_Card_Waiting_Next_RenewalInputs */



/**
* | output |
* | --- |
* | "Changes waiting for your next renewal" |
*
* @param {Seat_Types_Card_Waiting_Next_RenewalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_waiting_next_renewal = /** @type {((inputs?: Seat_Types_Card_Waiting_Next_RenewalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_Waiting_Next_RenewalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Änderungen zu Ihrer nächsten Verlängerung")
	return /** @type {LocalizedString} */ ("Changes waiting for your next renewal")
});